<template>
    <div class="qksm qksm4 page">
        <h4>四、关于财政拨款收支预算总表的说明</h4>
        <div class="nogap">
            <p>
                {{$store.state.divData.divname}}{{$parent.year}}年财政拨款收支总预算为{{isMoney(T4.总计)}}万元。
            </p>
            <p>
                收入包括：
                <template v-for="(item, idx) in T4.收入">
                    {{item.name}}{{isMoney(item.value)}}万元，占{{getPercentValue(T4.收入.map(e=>e.value), idx, 2)}}{{idx==T4.收入.length-1?'。':'；'}}
                </template>
            </p>
        </div>
        <div id="myChart41" class="echart" v-if="(!isPdf && $parent.isData) || isPdf"></div>
        <div class="nogap">
            <p v-if="T4.支出.length>0">
                支出包括：
                <template v-for="(item, idx) in T4.支出">
                    {{item.name}}（类）支出{{isMoney(item.value)}}万元，占{{getPercentValue(T4.支出.map(e=>e.value), idx, 2)}}{{idx==T4.支出.length-1?'。':'；'}}
                </template>
            </p>
        </div>
        <div id="myChart4" class="echart" v-if="(!isPdf && $parent.isData) || isPdf"></div>
        <p></p>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm4",
        data() {
            return {
                isPdf: this.$parent.isPdf,
                qksm: this.$store.state.divData.qksm,
            }
        },
        props: {
            T4: {
                type: Object,
                default: "",
            },
        },
        components: {
            reason,
        },
    };
</script>
